import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, sans-serif',
    h1: {
      fontSize: '93px',
      fontWeight: 600,
      color: '#0B1F3B', // Deep navy for big titles
    },
  },
  palette: {
    mode: 'light',

    // Deep navy as primary brand color
    primary: {
      main: '#0B1F3B',   // navy
      light: '#4B5563',  // softer dark gray/blue for hovers
      dark: '#050A16',
      contrastText: '#FFFFFF',
    },

    // Teal accent for actions/highlights
    secondary: {
      main: '#1ABC9C',   // teal accent
      light: '#4FD1B9',
      dark: '#12836D',
      contrastText: '#0B1F3B',
    },

    // Bright, clean background
    background: {
      default: '#F9FAFB', // page background
      paper: '#FFFFFF',   // cards, surfaces
    },

    // Text tuned for light background
    text: {
      primary: '#0B1F3B', // navy
      secondary: '#4B5563', // neutral dark gray
    },
  },
});
